import { useDispatch } from 'react-redux';

import { AppDispatch } from './types';

// Typed useDispatch that accepts thunks — use everywhere instead of `useDispatch<AppDispatch>()`.
// Kept in its own module (not store/index.ts) so importing it doesn't pull in the reducers barrel
// via store/index.ts, which would create an import cycle for reducer-adjacent consumers.
export const useAppDispatch = () => useDispatch<AppDispatch>();
